export default __webpack_public_path__ + "assets/json/ae735cf54407885c521e738fb7b970c6.json";